module.exports = __webpack_public_path__ + "User HCO Requests.1aa82f81864b236c2c22.png";